/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MainDashboard } from '../models/MainDashboard';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MainDashboardService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get various statistics calculated from compliance item definitions in the DB.
     * @param orgGuid
     * @returns MainDashboard OK
     * @throws ApiError
     */
    public getComplianceItemStatistics(
        orgGuid?: string,
    ): CancelablePromise<MainDashboard> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/MainDashboard/GetComplianceItemStatistics',
            query: {
                'orgGuid': orgGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
